import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { bugsnagNotify } from '@ui/components/bugsnag';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, q) => {
      console.error('error at query', q.queryKey);
      console.error(error);
      bugsnagNotify(
        new Error(`error at query: [${q.queryKey.toString()}]`, {
          cause: error,
        }),
      );
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (!shouldNotifyError(error)) return;
      console.error('error at mutation');
      console.error(error);
      bugsnagNotify(error);
    },
  }),
});

// will notify if it's something else than wallet "user rejected"
const shouldNotifyError = (error: Error) =>
  !('reason' in error) || error.reason !== 'rejected';
